import { render, staticRenderFns } from "./ModalCompanyNews.vue?vue&type=template&id=39e8cfef"
import script from "./ModalCompanyNews.vue?vue&type=script&lang=js"
export * from "./ModalCompanyNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports